import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: "12px 12px 0 0",
    boxShadow: "none",
    [theme.breakpoints.up("md")]: {
      "&:hover": {
        "& img": {
          opacity: 0.5,
        },
        '& [id^="next-photo-button-"], & [id^="previous-photo-button-"]': {
          opacity: 0.75,
          transition: "opacity 0.4s ease 0s",
        },
      },
    },
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: 2,
    marginTop: 4,
  },
  cardContent: {
    padding: 0,
    "&:last-child": {
      padding: 0,
    },
  },
  imageContainer: {
    position: "relative",
    "& img": {
      borderRadius: 8,
    },
  },
  imageChip: {
    position: "absolute",
    top: 10,
    left: 10,
    zIndex: theme.zIndex.vehicleCardChip,
  },
  focusHighlight: {
    backgroundColor: theme.palette.basic.white,
  },
  swipeableImage: {
    borderRadius: "12px 12px 0 0",
    aspectRatio: "3/2",
  },
}));
